module.exports = __webpack_public_path__ + "static/media/selecta_chamizal.7af69c27.png";